import { createFeature, createReducer, on } from '@ngrx/store';

import * as EmergencyControlActions from './emergency-control.actions';
import {
  UnfreezeAccountResponse,
  FreezeNoticeResponse,
} from '../models/emergency-control.model';

export const emergencyControlFeatureKey = 'emergencyControl';

export interface EmergencyControlState {
  response: UnfreezeAccountResponse | null;
  freezeNotice: FreezeNoticeResponse | null;
  loading: boolean;
  freezeNoticeLoading: boolean;
  error: string | null;
  freezeNoticeError: string | null;
}

const INITIAL_STATE: EmergencyControlState = {
  response: null,
  freezeNotice: null,
  loading: false,
  freezeNoticeLoading: false,
  error: null,
  freezeNoticeError: null,
};

const reducer = createReducer(
  INITIAL_STATE,
  on(
    EmergencyControlActions.unfreezeAccount,
    (state: EmergencyControlState) => ({
      ...state,
      loading: true,
      error: null,
    })
  ),
  on(
    EmergencyControlActions.unfreezeAccountSuccess,
    (state: EmergencyControlState, { response }) => ({
      ...state,
      loading: false,
      response,
    })
  ),
  on(
    EmergencyControlActions.unfreezeAccountFailure,
    (state: EmergencyControlState, { error }) => ({
      ...state,
      loading: false,
      error,
    })
  ),
  on(
    EmergencyControlActions.loadFreezeNotice,
    (state: EmergencyControlState) => ({
      ...state,
      freezeNoticeLoading: true,
      freezeNoticeError: null,
    })
  ),
  on(
    EmergencyControlActions.loadFreezeNoticeSuccess,
    (state: EmergencyControlState, { freezeNotice }) => ({
      ...state,
      freezeNoticeLoading: false,
      freezeNotice,
    })
  ),
  on(
    EmergencyControlActions.loadFreezeNoticeFailure,
    (state: EmergencyControlState, { error }) => ({
      ...state,
      freezeNoticeLoading: false,
      freezeNoticeError: error,
    })
  )
);

export const emergencyControlFeature = createFeature({
  name: emergencyControlFeatureKey,
  reducer,
});

export const {
  selectEmergencyControlState,
  selectError: selectEmergencyControlError,
  selectLoading: selectEmergencyControlLoading,
  selectResponse: selectEmergencyControlResponse,
  selectFreezeNotice,
  selectFreezeNoticeLoading,
  selectFreezeNoticeError,
} = emergencyControlFeature;
